import type { Release } from './types';

export function releaseKey(release: Release): string {
  // The server sends no download link or external id (they travel sealed in `link`): the signature identifies the release.
  return release.id ?? release.token ?? release.releaseName;
}
